import { $axios } from '@/modules/http/axios'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
import emitter from '@/modules/events/emitter'

const driversModule = {
  namespaced: true,

  actions: {
    async updateDriverDate ({ commit }, payLoad) {
      const driver = payLoad.driver
      const dateType = payLoad.dateType

      const dialogResult = await Swal.fire({
        title: `Zaktualizuj datę dla kierowcy: ${driver.firstName} ${driver.surname}`,
        icon: 'question',
        confirmButtonText: 'Zatwierdź',
        showCancelButton: true,
        html: `<input class="form-control" id="editable-date" type="datetime-local" value="${driver[dateType] ? moment(driver[dateType]).tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm') : moment().tz('Europe/Warsaw').format('YYYY-MM-DDTHH:mm')}">`
      })

      if (dialogResult.isConfirmed) {
        const putData = {
          firstName: driver.firstName,
          surname: driver.surname,
          cardNumber: driver.cardNumber,
          phonePrefix: driver.phonePrefix,
          workNumber: driver.workNumber,
          textColor: driver.textColor,
          backgroundColor: driver.backgroundColor,
          arrivalDate: dateType === 'arrivalDate' ? document.getElementById('editable-date').value : driver.arrivalDate,
          plannedDepartureDate: dateType === 'plannedDepartureDate' ? document.getElementById('editable-date').value : driver.plannedDepartureDate
        }

        try {
          await $axios.put(`Driver/${driver.id}`, putData)
          await Swal.fire('Pomyślnie zaktualizowano wybraną datę', '', 'success')
          emitter.emit('refreshed')
        } catch (e) {
          await Swal.fire(
            'Nie udało się zaktualizować wybranej daty',
            `System nie był w stanie wykonać żądanej operacji. <br> <span class="fw-bold">Kod błędu: ${e.response.status}</span>`,
            'error'
          )
        }
      }
    }
  }
}

export default driversModule
